export default "/institutions/mercantil.svg";